<svg
  width="18"
  height="16"
  viewBox="0 0 18 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.816 7.23189C12.9917 7.05616 13.2767 7.05616 13.4524 7.23189C13.6282 7.40758 13.6282 7.69249 13.4524 7.86819L8.95244 12.3682C8.86455 12.4561 8.74941 12.5 8.63424 12.5C8.51906 12.5 8.40392 12.4561 8.31603 12.3683L3.81603 7.86827C3.6403 7.69255 3.6403 7.40758 3.81603 7.23189C3.99178 7.05616 4.27669 7.05616 4.45244 7.23189L8.18423 10.9636V0.800037C8.18423 0.551524 8.38572 0.350037 8.63424 0.350037C8.88275 0.350037 9.08424 0.551524 9.08424 0.800037V10.9636L12.816 7.23189ZM1.43423 15.65H15.8342C16.5786 15.65 17.1842 15.0444 17.1842 14.3V12.5C17.1842 12.2514 16.9828 12.05 16.7342 12.05C16.4857 12.05 16.2842 12.2514 16.2842 12.5V14.3C16.2842 14.5481 16.0823 14.75 15.8342 14.75H1.43423C1.18611 14.75 0.984228 14.5481 0.984228 14.3V12.5C0.984228 12.2514 0.782741 12.05 0.534228 12.05C0.285716 12.05 0.0842285 12.2514 0.0842285 12.5V14.3C0.0842285 15.0444 0.689844 15.65 1.43423 15.65Z"
    fill="currentColor"
  />
</svg>
